<div>
  <form id="site-carte-form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="selectLevelOne">{{ 'GLOBAL.NIVEAU' | translate }} 1</label>
      <ng-select name="selectLevelOne" id="selectLevelOne" [(ngModel)]="configurationTreeview().niveauUn" (change)="onChangeConfiguration()" [clearable]="false">
        @for (configuration of Constants.ConfigurationNiveauUn; track configuration) {
          <ng-option [value]="configuration.id">{{ configuration.nom | translate }}</ng-option>
        }
      </ng-select>
    </div>
    <div class="form-group">
      <label for="selectLevelTwo">{{ 'GLOBAL.NIVEAU' | translate }} 2</label>
      <ng-select name="selectLevelTwo" id="selectLevelTwo" [(ngModel)]="configurationTreeview().niveauDeux" (change)="onChangeConfiguration()" [clearable]="false">
        @for (configuration of configurationTreeviewNiveauDeux(); track configuration) {
          <ng-option [value]="configuration.id"> {{ configuration.nom | translate }}</ng-option>
        }
      </ng-select>
    </div>
    <div class="form-group">
      <label for="selectLevelThree">{{ 'GLOBAL.NIVEAU' | translate }} 3</label>
      <ng-select name="selectLevelThree" id="selectLevelThree" [(ngModel)]="configurationTreeview().niveauTrois" (change)="onChangeConfiguration()" [clearable]="false">
        @for (configuration of configurationTreeviewNiveauTrois(); track configuration) {
          <ng-option [value]="configuration.id">{{ configuration.nom | translate }}</ng-option>
        }
      </ng-select>
    </div>
    <div class="btn-group" role="group">
      <button type="submit" class="btn btn-outline-success">{{ 'GLOBAL.VALIDER' | translate }}</button>
    </div>
  </form>
</div>
